import { baseURL } from "../utils/constants";
import apiClient from "./fetch";

export interface SectionPayload {
  sectionName: string;
  content: Record<string, any>;
  attachments: string[];
}

/**
 * POST /api/report/section
 * Submits a section (AWS, WhatsappBot, Dashboard, TV).
 */
export const submitReportSection = async (data: SectionPayload) => {
  try {
    const response = await apiClient.post(`https://test.doctrue.in/api/v1/daily-reports/section`, data);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error(
        "Report Section API Error:",
        error.response.status,
        error.response.data
      );
      return Promise.reject(
        new Error(error.response.data.message || "Failed to submit report section")
      );
    }
    console.error("Unexpected API Error:", error);
    throw error;
  }
};

/**
 * GET /api/report/status/:date
 * Fetches report submission status for the given date.
 */
export const getReportStatusByDate = async (date: string) => {
  try {
    const response = await apiClient.get(`https://test.doctrue.in/api/v1/daily-reports/status/${date}`);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error(
        "Report Status API Error:",
        error.response.status,
        error.response.data
      );
      return Promise.reject(
        new Error(error.response.data.message || "Failed to fetch report status")
      );
    }
    console.error("Unexpected API Error:", error);
    throw error;
  }
};
